module.exports = __webpack_public_path__ + "media/customizations/bramlife/back-68f8da14b797e72e16520725a5f7f39f.jpg";